import React, { useEffect, useState } from "react";
import axios from "axios";
import {config} from  '../library/comoda'
import {baseUrl} from  '../library/comoda'
import Speedometer from '../component/speedometer'
import Submit from '../component/submit'


interface DashboardProps {}

const Dashboard: React.FC<DashboardProps> = () => {
   
  const [StatoResponseRam, setStatoResponseRam] = useState<any>(null);
  const [StatoResponseCPU, setStatoResponseCPU] = useState<any>(null);
  const [StatoResponseRoot, setStatoResponseRoot] = useState<any>(null);
  const [StatoResponsePlex, setStatoResponsePlex] = useState<any>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
          const response = await axios.post(`${baseUrl}dashboard.php`,
            {},
            config
            )
            setStatoResponseRam(response.data);
            setStatoResponseCPU(response.data);
            setStatoResponseRoot(response.data);                                    
            setStatoResponsePlex(response.data);                                    
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData().then();
  }, []); // Runs only once after the initial render.  
  return (

    <div className="dash-scroll">
  <div className="gaugeBox">
       <div className='GaugeHolder'>
      <h3>CPU:</h3>
   <Speedometer id='CPU' data={StatoResponseCPU?.cpu} testo=''></Speedometer>
   <Submit id='updateCPU'  classe="updateGauge" value='Update CPU Monitor' endpoint={`${baseUrl}dashboard.php?t=c`} campi='' setStatoResponse={setStatoResponseCPU}></Submit>
   </div>
    <div className='GaugeHolder'>
    <h3>RAM:</h3>
   <Speedometer id='Ram' data={StatoResponseRam?.ram} testo=''></Speedometer>
   <Submit id='updateRam' classe="updateGauge" value='Update RAM Monitor' endpoint={`${baseUrl}dashboard.php?t=r`} campi='' setStatoResponse={setStatoResponseRam}></Submit>
   </div>
   <div className='GaugeHolder'>
   <h3>Root Disk:</h3>
   <Speedometer id='Root' data={StatoResponseRoot?.disk[0]} testo=''></Speedometer>
   <Submit id='updateRoot'  classe="updateGauge" value='Update Root Monitor' endpoint={`${baseUrl}dashboard.php?t=d`} campi='' setStatoResponse={setStatoResponseRoot}></Submit>
   </div>
   <div className='GaugeHolder'>
   <h3>Media  Disk:</h3>
   <Speedometer id='PlexMount' data={StatoResponsePlex?.disk[4]} testo=''></Speedometer>
   <Submit id='updatePlexMount'  classe="updateGauge" value='Update Media Disk Monitor' endpoint={`${baseUrl}dashboard.php?t=d`} campi='' setStatoResponse={setStatoResponsePlex}></Submit>
   </div>
  </div>
  </div>
  );
};

export default Dashboard;

